import { useTranslation } from "react-i18next";
import LocaleLink from "views/components/LocaleLink";

const RootCareersNav = () => {
	const { t } = useTranslation();

	return (
		<nav className="root-home-nav h-100" aria-label={t("titles.home_navigation")}>
			<ul
				className="nav row gx-1 gx-md-2 gx-lg-3 flex-nowrap align-items-center justify-content-end h-100"
				role="menu">
				<li className="nav-item col-auto d-none d-md-list-item" role="menuitem">
					<a
						href="#root-main"
						className="btn btn-link nav-link nav-link-skip text-uppercase text-decoration-none visually-hidden-focusable rounded-pill">
						<small>
							<strong>{t("actions.skip_to_content")}</strong>
						</small>
					</a>
				</li>
				<li className="nav-item col-auto col-lg-6" role="menuitem">
					<LocaleLink to="/" className="btn btn-link rounded-pill w-100 text-uppercase">
						<small>
							<strong>{t("actions.back_to_main_page")}</strong>
						</small>
					</LocaleLink>
				</li>
			</ul>
		</nav>
	);
};

export default RootCareersNav;
